import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Dispatch/Logistics Module Service Stores
 * Updated to match backend api-types
 *
 * Note: The dispatch services don't have a dedicated api-types folder.
 * Related services may be found in the logistics api-types folder.
 * Keeping existing services for backward compatibility.
 */
export const dispatchStores: ServiceStoreConfig[] = [
  // Keeping existing services for now as they don't have api-types yet
  // These may need to be moved to logistics.stores.ts in the future
];
